import React from 'react'
import styles from './CanvasLab.module.scss'

const STATUS_LABELS = {
  good: 'Layout looks good',
  review: 'Layout needs review',
  'needs-attention': 'Layout needs attention',
  unavailable: 'Layout check pending',
}

/** Route-local presentation of shared, read-only SVG layout diagnostics. */
export default function CanvasLayoutDiagnostics({ diagnostics }) {
  if (!diagnostics) return <section className={styles.layoutDiagnostics}><h3>Layout health</h3><p>Checking the rendered chart…</p></section>

  return <section className={styles.layoutDiagnostics} aria-label="Chart layout health">
    <h3>Layout health</h3>
    <p className={`${styles.layoutStatus} ${styles[`layoutStatus${diagnostics.status}`] || ''}`}>
      {STATUS_LABELS[diagnostics.status] || STATUS_LABELS.unavailable}
    </p>
    {diagnostics.issues?.length > 0 && <ul>
      {diagnostics.issues.map((issue) => <li key={issue.code}>{issue.message}</li>)}
    </ul>}
  </section>
}
